import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActiveFacetsComponent } from '@spartacus/storefront';
import { FacetCodes } from '@app/custom/features/rrs-product-listing/model';
import { RrsFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-facet-service/rrs-facet.service';
import { RrsProductFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-product-facet-service.service';
import { RoutingService } from '@spartacus/core';

@Component({
  selector: 'rrs-active-facets',
  templateUrl: './rrs-active-facets.component.html',
  styleUrls: ['./rrs-active-facets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RrsActiveFacetsComponent extends ActiveFacetsComponent {
  facetCodes = FacetCodes;

  facetsData$ = this.facetService.getFacetData();

  constructor(
    protected facetService: RrsFacetService,
    protected productFacetService: RrsProductFacetService,
    protected routingService: RoutingService
  ) {
    super(facetService);
  }

  getTranslationKey(facetName: string): string {
    return this.facetService.getTranslationKey(facetName);
  }
}
